import { getIdToken } from "../auth";

let presignedBaseUrl: string | null = null;

export function setPresignedBlobBaseUrl(url: string | undefined): void {
  const trimmed = url?.trim().replace(/\/$/, "") ?? "";
  presignedBaseUrl = trimmed || null;
}

export function getPresignedBlobBaseUrl(): string | null {
  return presignedBaseUrl;
}

async function signedDownloadURL(s3Key: string): Promise<string> {
  const base = presignedBaseUrl;
  if (!base) throw new Error("Storage cloud non configurato.");
  const token = await getIdToken();
  const res = await fetch(`${base}/blob/download-url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-oidc-token": token,
    },
    body: JSON.stringify({ s3Key }),
  });
  const text = await res.text();
  if (!res.ok) {
    throw new Error(`Download URL (${res.status}): ${text.slice(0, 200)}`);
  }
  const json = JSON.parse(text) as { url?: string };
  if (!json.url) throw new Error("Risposta download non valida.");
  return json.url;
}

export async function downloadBlobText(s3Key: string): Promise<string> {
  const signed = await signedDownloadURL(s3Key);
  const res = await fetch(signed);
  if (!res.ok) throw new Error(`Download blob (${res.status})`);
  const raw = (await res.text()).trim();
  if (!raw) throw new Error("Output assistente vuoto.");
  try {
    const obj = JSON.parse(raw) as Record<string, unknown>;
    for (const key of ["outputText", "text", "content"]) {
      const inner = obj[key];
      if (typeof inner === "string" && inner.trim()) return inner.trim();
    }
  } catch {
    /* plain text */
  }
  return raw;
}
